import { Module } from "@nestjs/common";
import { ScheduleModule } from "@nestjs/schedule";
import { TypeOrmModule } from "@nestjs/typeorm";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { BuyerEntity } from "./dto/buyer-entity";
import { MeasurementDataShahiCarharttEntity } from "./dto/color-carhartt.entity";
import { WfxImageUploadEntity } from "./dto/file-upload-entity";
import { MeasurementDataEntity } from "./dto/measurement-data-entity";
import { ParameterEntity } from "./dto/parameter-entity";
import { StylesEntity } from "./dto/style-carhartt.entity";
import { UnitTweleveExcelDataEntity } from "./dto/unit-twelve-excel.entity";
import { UnitTwelevFileUploadEntity } from "./dto/unit-twleve-file.entity";
import { WfxFileUploadEntity } from "./dto/wfx-file.entity";
import { ApparelArticleMaster } from "./entities/tech-pack/apparel-article-master.entity";
import { FabricTrimsMaster } from "./entities/tech-pack/fabric-trims-master.entity";
import { MeasurementChart2T } from "./entities/tech-pack/measurement-chart-2t.entity";
import { MeasurementChartMonths } from "./entities/tech-pack/measurement-chart-6-12-months.entity";
import { ApparelArticleMasterRepo } from "./repositories/apparel-article-master.repo";
import { BuyerRepo } from "./repositories/buyer-repo";
import { ColorCarharttRepository } from "./repositories/color-carhartt-repo";
import { FabricTrimsMasterRepo } from "./repositories/fabric-trims-master.repo";
import { ImagesRepo } from "./repositories/images-repo";
import { MeasurementChart2TRepo } from "./repositories/measurement-chart-2t.repo";
import { MeasurementChartMonthsRepo } from "./repositories/measurement-chart-months.repo";
import { ParameterRepo } from "./repositories/parameter-repo";
import { StyleRepo } from "./repositories/style-repo";
import { UnitTweleveExcelRepo } from "./repositories/unit-tweleve-excel-repo";
import { UnitTwelveRepo } from "./repositories/unit-twleve-repo";
import { WfxRepository } from "./repositories/wfx-file-repo";
import { WFXAdapter } from "./wfx-adapter";
import { WfxController } from "./wfx.controller";
import { WfxService } from "./wfx.service";
import { ApparelArticleMasterVersions } from "./entities/tech-pack-versions/apparel-article-masters-versions.entity";
import { FabricTrimsMasterVersions } from "./entities/tech-pack-versions/fabric-trims-master-versions.entity";
import { MeasurementChart2TVersions } from "./entities/tech-pack-versions/measurement-chart-2t-versions.entity";
import { MeasurementChartMonthsVersions } from "./entities/tech-pack-versions/measurement-chart-6-12-months-versions.entity";
import { ApparelArticleMasterVersionsRepo } from "./repositories/versions-repos/apparel-article-master.repo";
import { FabricTrimsMasterVersionsRepo } from "./repositories/versions-repos/fabric-trims-master.repo";
import { MeasurementChart2TVersionsRepo } from "./repositories/versions-repos/measurement-chart-2t.repo";
import { MeasurementChartMonthsVersionsRepo } from "./repositories/versions-repos/measurement-chart-months.repo";
import { FolderUploadRepository } from "./repositories/folder-image-upload-repo";
import { FolderImageUploadEntity } from "./dto/folder-image-upload-entity";


@Module({
  imports: [
    ScheduleModule.forRoot(),
    TypeOrmModule.forFeature([
      WfxFileUploadEntity,
      WfxImageUploadEntity,
      MeasurementDataShahiCarharttEntity,
      MeasurementDataEntity,
      StylesEntity,
      BuyerEntity,
      ParameterEntity,
      UnitTwelevFileUploadEntity,
      UnitTweleveExcelDataEntity,
      ApparelArticleMaster,
      FabricTrimsMaster,
      MeasurementChart2T,
      MeasurementChartMonths,
      ApparelArticleMasterVersions,
      FabricTrimsMasterVersions,
      MeasurementChart2TVersions,
      MeasurementChartMonthsVersions,
      FolderImageUploadEntity,
    ])],
  controllers: [WfxController],
  providers: [
    WfxService,
    WfxRepository,
    ColorCarharttRepository,
    StyleRepo, BuyerRepo,
    ParameterRepo, ImagesRepo,
    UnitTwelveRepo,
    UnitTweleveExcelRepo,
    MeasurementChart2TVersionsRepo,
    MeasurementChartMonthsVersionsRepo,
    ApparelArticleMasterVersionsRepo,
    FolderUploadRepository,
    ApparelArticleMasterRepo,
    FabricTrimsMasterRepo,
    FabricTrimsMasterVersionsRepo,
    WFXAdapter, ApplicationExceptionHandler]
})
export class WfxModule { }
